<template>
  <v-card>
    <v-card-title class=" p-4 pb-3">
      <p 
        v-if="module.block"
        class="font-weight-black w-100 mb-0"
      >
        {{ module.block.trail.acronym }} | {{ module.block.name }} 
        <span v-if="module.block.suffix"> {{ module.block.suffix }} </span>
      </p>
      <hr 
        v-show="module.block"
        class="w-100 my-1"
      >
      <p class="w-100">
        <span class="font-weight-black">{{ module.name }}</span>
        <span v-if="module.description">{{ module.description }}</span>
      </p>
    </v-card-title>
    <div
      class="position-relative p-4 m-4"
      style="min-height: 300px"
    >
      <v-responsive :aspect-ratio="16/9">
        <script 
          ref="player"
          :data-videohub-id="module.video.content" 
          :src="`https://evolucional.videohub.com.br/embed.js?${now}`" 
          type="module"
        />
      </v-responsive>
    </div>
    <v-card-actions>
      <slot />
    </v-card-actions>
  </v-card>
</template>
<script>


export default {
    props: {
      module: {
        type: Object,
        required: true,
      },
  },
  computed: {
    now(){
      return new Date().getTime()
    }
  },
}
</script>
<style scoped>
  p{
    word-break: break-word;
  }
</style>
